export const fixedBannerConfig = [
    // Simple single div with height from SCSS (296px default + 56px padding on each side = 408px total)
    { span: 24, height: "300px" },
]
